import React, { FC } from 'react';
import { formatPhone, useScopedSelector } from 'ia-react-core';
import { Phone } from '../../interfaces/Phone';
import { StyledLine } from '../ContactInformation.styles';
import Section from '../../../../components/Section';
import { StyledTelLink } from './PhoneRow.styles';

export interface PhoneRowProps {
  title: string;
  numbers: Phone[];
  callable: boolean;
}

const PhoneRow: FC<PhoneRowProps> = ({ title, numbers, callable }) => {
  const language: string = useScopedSelector('/language.locale');
  return (
    <Section name={title}>
      {
        numbers.map((number) => (
          <StyledLine key={number.number}>
            {number.label ? `${number.label}${language === 'fr' ? ' ' : ''}: ` : null}
            {callable ?
              <StyledTelLink phone={number.number.toString()}>{formatPhone(number.number, { locale: language })}</StyledTelLink> :
              <span>{formatPhone(number.number, { locale: language })}</span>}
            {number.extension ? ` - ${number.extension}` : null}
          </StyledLine>
        ))
      }
    </Section>
  );
};

export default PhoneRow;
